module.exports = __webpack_public_path__ + "img/23.fdab5b42.jpg";